package kz.dentalcrm.app.screens.reply_by_template.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.quick_replies.QuickReply

sealed interface ReplyByTemplateViewEvent : ViewEvent {
    data class Init(val phone: String) : ReplyByTemplateViewEvent
    data object Reload : ReplyByTemplateViewEvent
    data class SelectReply(val reply: QuickReply) : ReplyByTemplateViewEvent
    data class MessageChanged(val value: String) : ReplyByTemplateViewEvent
    data object SendTelegram : ReplyByTemplateViewEvent
    data object SendWhatsApp : ReplyByTemplateViewEvent
}
